import { Icon } from '@iconify/react';
import {
    Close
} from '@mui/icons-material';
import { Box, Container, Grid2, IconButton, Modal, Typography } from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import { datesInCurrentWeek, getWeekdayPresence } from '../../consts/helpers';

// NOTE:
// default date format: MM-DD-YYYY
const ProgressCalendar = ({ open, handleClose, dateslist=[] }) => {
    const today = new Date();
    return (
        <Modal
        open={open}
        onClose={handleClose}
        >
        <Container maxWidth={'xs'} className='modal-container' sx={{ padding: 3 }}>
            <Box className='spread-x' sx={{ justifyContent: 'flex-end' }}>
                <IconButton onClick={handleClose}>
                    <Close />
                </IconButton>
            </Box>
            <Calendar 
                minDate={new Date('10-01-2024')}
                maxDate={new Date(today.getFullYear(), today.getMonth() + 2, 0)}
                tileClassName={({ date, view }) => {
                    if(dateslist?.find(x=>x===moment(date).format("MM-DD-YYYY"))){
                        return  'calendar-highlight'
                    }
                }}
            />
        </Container>
        </Modal>
    )   
}

export default function ProgressTracker({ dateslist=[], isStreakType=false, streakType, streakCount=0, streakTotal=0, withPopup=true, withLabel=true }) {
    // For calendar popup
    const [openPopup, setOpenPopup] = useState(false);
    const handleOpen = () => setOpenPopup(true);
    const handleClose = () => setOpenPopup(false);

    // State to represent completion for each day of the week / streak
    const [progress, setProgress] = useState({});

    // For grid sizing of filler component
    const [gridSize, setGridSize] = useState(0);
    const [fillerSize, setFillerSize] = useState(0);

    useEffect(() => {
        let progressObj = {}
        if (isStreakType) {
            progressObj = Object.fromEntries(Array.from({ length: streakTotal }, (_, i) => [i + 1, i < streakCount]));
        } else {
            progressObj = getWeekdayPresence(datesInCurrentWeek(dateslist));
        }
        setProgress(progressObj);

        setGridSize(withPopup ? 1.5 : 12/(Object.keys(progressObj).length));
        setFillerSize((Object.keys(progressObj).length < 7) ? "grow" : 0);
    }, [isStreakType, streakCount, streakTotal]);

    return (
        <Box>
            { withPopup && <Typography variant="h6" gutterBottom sx={{ mt: 2 }}>Progress Tracker:</Typography> }
            <Grid2 container spacing={1}>
                {Object.entries(progress).map(([slot, isHighlighted], key) => (
                    <Grid2 key={key} size={gridSize} className="centered-container" >
                        <Box key={slot} className={`calendar-box ${withPopup ? "" : "calendar-box-mini"} ${isHighlighted ? "calendar-highlight" : ""}`}/>
                        { withLabel && <Typography variant="caption">{streakType === 'weekly' && 'Wk '}{slot.charAt(0)}{streakType === 'day' &&  <>&times;</>}</Typography> }
                    </Grid2>
                ))}

                {/* filler piece */}
                { (fillerSize!==0 && withPopup) && <Grid2 size={fillerSize} /> }

                {
                    withPopup &&
                    <Grid2 size={gridSize} className="centered-y">
                        <IconButton onClick={handleOpen}>
                            <Icon icon="bxs:calendar" className="calendar-icon" style={{ fontSize: '30px'}} />
                        </IconButton>
                    </Grid2>
                }
            </Grid2>

            <ProgressCalendar open={openPopup} handleClose={handleClose} dateslist={dateslist} />
        </Box>
    );
};